/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Useful build information to quickly identify the build artifact name, version, time created, etc. It could come in handy to check if the team deployed the relevant version of the app.
 */
export interface ActuatorBuildInfo { 
    /**
     * The build time
     */
    readonly time?: string;
    /**
     * The build version
     */
    readonly number?: string;
    /**
     * Deployment stage
     */
    readonly stage?: string;
    /**
     * The id of the AWS API
     */
    readonly apiId?: string;
}

